import Image from 'next/image';

import { CarouselItem } from '@components/ui/Carousel';
import Typography from '@components/ui/Typography';

interface FeedbackCarouselItemProps {
  testimonial: {
    text: string;
    author: string;
  };
}

export default function FeedbackCarouselItem({
  testimonial: { text, author },
}: FeedbackCarouselItemProps) {
  return (
    <CarouselItem className="basis-[324px] pl-6 sm:basis-[346px]">
      <div className="flex h-[398px] w-full flex-col rounded-lg bg-grayBg p-6 sm:h-[472px]">
        <div className="mb-6 text-6xl text-gray-300">
          <Image src="/icons/quotes.svg" alt="Quotes" width={40} height={30} />
        </div>
        <Typography intent="headlineMedium" className="text-secondary">
          {text}
        </Typography>
        <div className="mt-auto flex items-center gap-3">
          <div className="size-10 rounded-full bg-white">
            <Image
              src="/icons/person.svg"
              alt="Person"
              width={40}
              height={40}
            />
          </div>
          <Typography intent="bodyMedium" className="text-secondary">
            {author}
          </Typography>
        </div>
      </div>
    </CarouselItem>
  );
}
